import{styled as i}from"@mui/material/styles";import{DIALOG_WIDTH as o,VIEW_HEIGHT as t}from"../../constants/dimensions.js";const e=i("div")({overflow:"hidden",width:o,maxHeight:t,display:"flex",flexDirection:"column",margin:"0 auto"});export{e as PickerViewRoot};
//# sourceMappingURL=PickerViewRoot.js.map
